import React from 'react';
import PropTypes from 'prop-types';
import Case from 'case';
import { paths } from '@Components/configs';
import {
  Box, Text, Anchor,
} from 'grommet';

const renderSummaryValue = (value) => {
  if (Array.isArray(value)) {
    if (value.length === 0 || value.every((v) => v === '' || v === null || v === undefined)) {
      return 'N/A';
    }
    return value.filter(Boolean).join(', ');
  }
  if (value === '' || value === null || value === undefined) {
    return 'N/A';
  }
  return String(value);
};

const ImportResultSummary = ({
  importResult,
  textColor,
  clearImportResult,
  hideHistoryLink = false,
}) => {
  if (!importResult) return null;

  const {
    summary = {},
    errors = [],
    fileImportId,
    fileImportName,
  } = importResult;

  return (
    <Box direction="column" gap="1rem" width="100%">
      {/* Summary Section */}
      {summary && Object.keys(summary).length > 0 && (
        <Box gap="0.5rem">
          <Box gap="0.5rem">
            <Text size="1rem" color={textColor}>
              File Import ID:
              {' '}
              <Text weight={600} color={textColor}>{fileImportId}</Text>
            </Text>
            {fileImportName && (
              <Text size="1rem" color={textColor}>
                File Import Name:
                {' '}
                <Text weight={600} color={textColor}>{fileImportName}</Text>
              </Text>
            )}
            {Object.entries(summary).map(([key, value]) => (
              <Text key={key} size="1rem" color={textColor}>
                {`${Case.title(key)}: `}
                <Text weight={600} color={textColor}>{renderSummaryValue(value)}</Text>
              </Text>
            ))}
          </Box>
        </Box>
      )}
      {/* Errors Section */}
      {errors && errors.length > 0 && (
        <Box gap="0.5rem" border={{ side: 'top', color: 'var(--nav-border)' }} width="100%">
          <Text weight={700} size="1.25rem" color={textColor}>Errors</Text>
          <Box gap="0.5rem">
            {errors.map((err) => (
              <Text
                key={typeof err === 'string' ? err : JSON.stringify(err)}
                size="1rem"
                color={textColor}
              >
                {typeof err === 'string' ? err : JSON.stringify(err)}
              </Text>
            ))}
          </Box>
        </Box>
      )}
      {!hideHistoryLink && (
        <Anchor href={paths.adminFileImportsHistory} onClick={() => clearImportResult()}>
          <Box align="center" justify="center" width="100%">
            <Text size="0.85rem" color="var(--page-alt-highlight)" textAlign="center">
              File Imports history page →
            </Text>
          </Box>
        </Anchor>
      )}
    </Box>
  );
};

ImportResultSummary.propTypes = {
  importResult: PropTypes.shape({
    fileImportId: PropTypes.string,
    fileImportName: PropTypes.string,
    summary: PropTypes.object,
    errors: PropTypes.arrayOf(PropTypes.any),
  }),
  textColor: PropTypes.string.isRequired,
  clearImportResult: PropTypes.func.isRequired,
  hideHistoryLink: PropTypes.bool,
};

export default ImportResultSummary;
